<div class="np-date-field">
  <label class="np-label" *ngIf="label">{{ label }}<span class="req" *ngIf="required"> *</span></label>
  <div class="np-input-wrap">
    <mat-form-field appearance="outline" class="np-mat-field" subscriptSizing="dynamic">
      <input matInput [matDatepicker]="picker" [placeholder]="placeholder"
             [(ngModel)]="value" (dateChange)="onDateChange($event.value)"
             [max]="maxDate" [min]="minDate" [disabled]="disabled" readonly>
      <mat-datepicker-toggle matIconSuffix [for]="picker" class="np-toggle">
        <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #picker panelClass="np-datepicker-panel"></mat-datepicker>
    </mat-form-field>
  </div>
</div>
